import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface DashboardModuleSharedWidgetsPendingWidgetState {
    value: StrictNullable<number>
    laboratoryId: number
}
export const initialDashboardModuleSharedWidgetsPendingWidgetState =
    (): DashboardModuleSharedWidgetsPendingWidgetState => ({
        value: null,
        laboratoryId: store.getters.labId
    })

export enum DashboardModuleUIComponentsWidgets {
    GROSSING = 'uicomponent.grossing.samplepanel',
    LABORATORY = 'uicomponent.laboratory.sidepanel'
}
